import { dom } from "@omegagrid/core";
import { FormContainer } from "@omegagrid/form";
import rp, { SyncEditorAdapter, SyncEditorOptions, SyncFormAdapter } from "@reporting/rp-app-host";
import { AccountingTreeAdapter } from "@reporting/rp-mf-accounting";
import { ObjectShare } from "@reporting/rp-types/core";

export class MdmSyncEditorAdapter extends SyncEditorAdapter {

	async delete(idz: number) {
		await rp.ms('mdm').delete(`sync/objects/${idz}`);
	}

	async synchronize() {
		await rp.ms('mdm').get('sync');
	}

	async getEditFormComponent(idz: number): Promise<HTMLElement> {
		const component = dom.createElement<FormContainer>('og-form-container');
		component.adapter = new SyncFormAdapter(
			rp.ms('mdm'),
			[{
				key: 'accounting_share',
				// every company the user may see but this one, as a tree by groups
				getSourceData: () => new AccountingTreeAdapter({ excludedAccounting: rp.accountingProvider.a, byGroups: true }).getTree(),
			}],
			idz
		);
		return component;
	}

	async getObjects(): Promise<ObjectShare[]> {
		const objects = await rp.ms('mdm').get<ObjectShare[]>('sync/objects');
		return objects;
	}

	getOptions(): Partial<SyncEditorOptions> {
		return this.createOptions({
			listItemFields: ['company', 'date_created', 'who_created'],
			columns: ['company', 'date_created', 'who_created'], // the object is the whole module
		});
	}

}
